var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contactUs"},[_c('NavbarOther'),_c('Contact'),_c('Link'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }